var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.success||_vm.notFound)?_c(_vm.tag,{tag:"component"},[_vm._v(_vm._s(_vm.rdata && _vm.rdata[_vm.property] ? _vm.rdata[_vm.property] : _vm.emptyValue))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }